import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { Modal, useForm } from '../components/helpers';

const EMPTY = { name: '', contact: '', phone: '', email: '', address: '', notes: '' };

export default function Suppliers() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [editing, setEditing] = useState(null);
  const [form, set, setForm] = useForm(EMPTY);

  async function load() {
    const { data } = await supabase.from('suppliers').select('*').order('name');
    setItems(data || []);
    setLoading(false);
  }
  useEffect(() => { load(); }, []);

  function openAdd() { setForm(EMPTY); setEditing(null); setModal('form'); }
  function openEdit(item) {
    setForm({ name: item.name, contact: item.contact || '', phone: item.phone || '', email: item.email || '', address: item.address || '', notes: item.notes || '' });
    setEditing(item); setModal('form');
  }

  async function save() {
    if (!form.name) { alert('Supplier name is required.'); return; }
    const payload = { name: form.name.trim(), contact: form.contact.trim(), phone: form.phone.trim(), email: form.email.trim(), address: form.address.trim(), notes: form.notes.trim() };
    if (editing) {
      await supabase.from('suppliers').update(payload).eq('id', editing.id);
    } else {
      await supabase.from('suppliers').insert(payload);
    }
    setModal(null); load();
  }

  async function del(id) {
    if (!window.confirm('Delete this supplier? This will not affect existing SKUs.')) return;
    await supabase.from('suppliers').delete().eq('id', id);
    load();
  }

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Suppliers</div>
          <div className="page-sub">Manage suppliers — used as dropdown when adding SKUs and POs</div>
        </div>
        <button className="btn btn-primary" onClick={openAdd}>+ Add Supplier</button>
      </div>

      <div className="tbl-wrap">
        <table>
          <thead><tr><th>Name</th><th>Contact</th><th>Phone</th><th>Email</th><th>Address</th><th>Notes</th><th>Actions</th></tr></thead>
          <tbody>
            {loading && <tr className="empty-row"><td colSpan={7}>Loading...</td></tr>}
            {!loading && items.length === 0 && <tr className="empty-row"><td colSpan={7}>No suppliers yet. Add your first supplier.</td></tr>}
            {items.map(item => (
              <tr key={item.id}>
                <td><strong>{item.name}</strong></td>
                <td className="text-muted">{item.contact || '—'}</td>
                <td className="text-muted">{item.phone || '—'}</td>
                <td className="text-muted">{item.email || '—'}</td>
                <td className="text-muted" style={{ fontSize: 12 }}>{item.address || '—'}</td>
                <td className="text-muted" style={{ fontSize: 12 }}>{item.notes || '—'}</td>
                <td>
                  <div className="flex-row">
                    <button className="btn btn-sm" onClick={() => openEdit(item)}>Edit</button>
                    <button className="btn btn-sm btn-danger" onClick={() => del(item.id)}>Del</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal === 'form' && (
        <Modal title={editing ? 'Edit Supplier' : 'Add Supplier'} onClose={() => setModal(null)} onSave={save}>
          <div className="form-group"><label className="form-label">Supplier Name *</label><input className="form-input" value={form.name} onChange={set('name')} placeholder="e.g. AF Manufacturing" autoFocus /></div>
          <div className="form-row">
            <div className="form-group"><label className="form-label">Contact Person</label><input className="form-input" value={form.contact} onChange={set('contact')} placeholder="e.g. John Smith" /></div>
            <div className="form-group"><label className="form-label">Phone</label><input className="form-input" value={form.phone} onChange={set('phone')} placeholder="e.g. 555-123-4567" /></div>
          </div>
          <div className="form-row">
            <div className="form-group"><label className="form-label">Email</label><input className="form-input" value={form.email} onChange={set('email')} placeholder="e.g. orders@supplier.com" /></div>
            <div className="form-group"><label className="form-label">Address</label><input className="form-input" value={form.address} onChange={set('address')} placeholder="e.g. 123 Main St, City, ST 12345" /></div>
          </div>
          <div className="form-group"><label className="form-label">Notes</label><input className="form-input" value={form.notes} onChange={set('notes')} placeholder="Optional notes" /></div>
        </Modal>
      )}
    </div>
  );
}
